import { gql } from '@apollo/client';
import { FR_MACHINE_TYPE_FIELDS } from './machineType';
import { FR_EQUIPMENT_TYPE_FIELDS } from './equipment';

export const FR_RESOURCE_ASSET_ALLOCATION_FIELDS = gql`
    fragment fr_ResourceAssetAllocationFields on ResourceAsset {
        __typename
        ... on Machine {
            MachineId
            SerialNbr
            Allocation(data: { StartDate: $StartDate, EndDate: $EndDate }) {
                TaskResourceId
                TaskResourceType
                StartDate
                EndDate
                Project {
                    ProjectId
                    Name
                    StartDate
                    EndDate
                }
            }
            MachineType {
                ...fr_MachineTypeFields
            }
            Asset {
                AssetName
                AssetType
            }
        }
        ... on Equipment {
            EquipmentId
            SerialNbr
            Allocation(data: { StartDate: $StartDate, EndDate: $EndDate }) {
                TaskResourceId
                TaskResourceType
                StartDate
                EndDate
                Project {
                    ProjectId
                    Name
                    StartDate
                    EndDate
                }
            }
            EquipmentType {
                ...fr_EquipmentTypeFields
            }
            EquipmentClass {
                EquipmentClassId
                Name
            }
            Asset {
                AssetName
                AssetType
            }
        }

        ... on User {
            UserId
            Lastname
            Firstname
            Fullname
            Email
            Allocation(data: { StartDate: $StartDate, EndDate: $EndDate }) {
                TaskResourceId
                TaskResourceType
                StartDate
                EndDate
                Project {
                    ProjectId
                    Name
                    StartDate
                    EndDate
                }
            }
            OwnOrganization {
                OrganizationId
                Name
            }
        }
    }
    ${FR_MACHINE_TYPE_FIELDS}
    ${FR_EQUIPMENT_TYPE_FIELDS}
`;


export const FR_RESOURCE_ASSET_FIELDS = gql`
    fragment fr_ResourceAssetFields on ResourceAsset {
        __typename
        ... on Machine {
            MachineId
            SerialNbr
            MachineType {
                ...fr_MachineTypeFields
            }
            Asset {
                AssetName
                AssetType
            }
        }
        ... on Equipment {
            EquipmentId
            SerialNbr
            EquipmentType {
                ...fr_EquipmentTypeFields
            }
            EquipmentClass {
                EquipmentClassId
                Name
            }
            Asset {
                AssetName
                AssetType
            }
        }

        ... on User {
            UserId
            Lastname
            Firstname
            Fullname
            Email
            OwnOrganization {
                OrganizationId
                Name
            }
        }
    }
    ${FR_MACHINE_TYPE_FIELDS}
    ${FR_EQUIPMENT_TYPE_FIELDS}
`;